import LargePopup from 'components/popup/large-popup'
import React, { useState, useEffect } from 'react';
import './index.css';
import { ClickableSpan, FormErrorMessageSpan, InputMintDiv } from 'views/common-styled-components';
import { SuccessBtnWhiteGreenBorder, SuccessButton } from 'components/button';
import { Controller, useForm } from 'react-hook-form';
import CustomRadio from 'components/custom-radio';
import { propsToJS } from '__utils/immutable-to-js';
import { useSelector } from 'react-redux';
import UserSelector from 'views/user/user.selector';
import { Col, DatePicker, Row } from 'antd';
import { useMediaQuery } from 'react-responsive';
import { COLOR } from 'constants/colors';
import Checkbox from '__utils/customisedCheckBox';
import { isMintproApp, redirectToHome } from '__utils/common-utils';
import { useDeepCompare } from 'hooks/use-deep-memo';
import { getAgentCode } from '__utils/storage';
import { Mixpanel, getEventName } from '__utils/mixpanel';
import { fetchPost, getFormDataFromJson } from '__utils/ajax-wrapper';
import { ENDPOINTS } from 'constants/endpoints';
import styled from 'styled-components';
import { CommonStyledComponentProps } from '__utils/type';
import useFlashToggler from 'hooks/use-flash-toggler';
import moment from 'moment';
import resolveURLParams from '__utils/url-params-resolver';
import TalkToExpert from 'components/talk-to-expert';
import callBtn from "images/call-expert-green.svg";
import { ArnNismImageSlab } from './know-more-helper';
import congratsTick from 'images/congrats-tick.svg';


const KnowMoreContainer = styled.div<CommonStyledComponentProps>`
    *,p{
        font-size: ${(props: CommonStyledComponentProps) => props.isMobile ? '14px' : '16px'};
        line-height: 1.5;
    }
    .submitBtn{
        margin: 0 auto;
        width: 180px;
    }
    .nism-txt{
        top: ${(props: CommonStyledComponentProps) => props.isMobile ? '121px' : '125px'};
    }
    #anchorTag{
        color: #236df1;
        cursor: pointer;
    }
`
interface KnowMoreProps {
    onClose: Function;
}

const KnowMorePopup: React.FC<KnowMoreProps> = ({ onClose }) => {

    const isMobile = useMediaQuery({ maxWidth: 767 });
    const flash = useFlashToggler();
    const { register, handleSubmit, getValues, reset, errors, control, watch, formState } = useForm({ mode: 'onChange' });
    const { agentCertificates } = propsToJS(useSelector(UserSelector));
    const [ARNDuplicate, setARNDuplicate] = useState<boolean>(false);
    const [NISMStatus, setNISMStatus] = useState<boolean>(false);
    const [ARNStatus, setARNStatus] = useState<boolean>(false);
    const [checkedTerms, setCheckedTerms] = useState<boolean>(false);
    const [showSuccessPopup, setShowSuccessPopup] = useState<any>({ show: false });

    const knowMoreWatch = watch();

    useEffect(() => {
        if (agentCertificates) {
            const formattedData = {
                ...agentCertificates,
                isARNHolder: agentCertificates?.arnCode ? 'true' : 'false',
                isNISMCertified: agentCertificates?.isNISMCertified === true ? 'true' : 'false',
                nismCode: (agentCertificates?.nismCode && agentCertificates?.nismCode?.startsWith("NISM-")) ? agentCertificates.nismCode?.substring(5) : "",
                arnCode: (agentCertificates.arnCode && agentCertificates.arnCode.startsWith("ARN-")) ? agentCertificates.arnCode.substring(4) : "",
                euin: (agentCertificates.euin && agentCertificates.euin.startsWith("E")) ? agentCertificates.euin.substring(1) : ""
            };
            reset(formattedData);

            if (!agentCertificates.isARNHolder) {
                // Need to trigger email after 10 mins if form is not submitted
                setTimeout(() => {
                    var data = {
                        agentCode: getAgentCode(),
                        isNISMCertified: false,
                        nismCode: "",
                        nismValidStartDate: "",
                        nismValidEndDate: "",
                        isARNHolder: false,
                        arnCode: "",
                        arnValidStartDate: "",
                        arnValidEndDate: "",
                    };
                    onSubmitDPdetails(data);
                }, 10 * 60 * 1000);
            }
        }
    }, [useDeepCompare(agentCertificates)])

    const nismRegisterOpenChrome = (event:any) => {
        event.preventDefault();
        Mixpanel.track(getEventName('nismRegister', 'clicked', 'know-more'))
        if (isMintproApp()) {
            var featurePayload = {
                type: 'chromeTab',
                payload: {
                    url: 'http://sprw.io/stt-f5e8cecaea', // URL to open in chrome tabs
                },
            };

            // Trigger the download
            window.postMessage(JSON.stringify(featurePayload), '*');
            window.location.reload();
        }
        else {
            window.open('http://sprw.io/stt-f5e8cecaea', '_blank');
        }
    };

    const openPdfFile = () => {
        const url = 'https://docs.turtlemintmoney.com/docs/ARN_NISM_TC.pdf';
        if (isMintproApp()) {
            var featurePayload = {
                type: 'chromeTab',
                payload: {
                    url: url
                },
            };
            window.postMessage(JSON.stringify(featurePayload), '*');
        } else {
            window.open(url, '_blank');
        }
    }

    const successCallback = (imageId: string, imgUrl: any) => {
        if (imageId === 'NISM') {
            setNISMStatus(true);
        }
        else {
            setARNDuplicate(false);
            setARNStatus(true);
        }
    }

    const onCancelPreviewBtn = (imageId: string) => {
        if (imageId === 'NISM') setNISMStatus(false)
        else {
            setARNStatus(false);
            setARNDuplicate(false);
        }

    }

    const onSubmitDPdetails = (data: any) => {
        const arnData = {
            agentCode: getAgentCode(),
            isARNHolder: data?.isARNHolder === 'true',
            isNISMCertified: data?.isNISMCertified === 'true',
            arnCode: data?.arnCode ? `ARN-${data?.arnCode}` : '',
            euin: data?.euin ? `E${data?.euin}` : '',
            nismCode: data?.nismCode ? `NISM-${data?.nismCode}` : '',
            arnValidEndDate: data?.arnValidEndDate ? moment(data?.arnValidEndDate).format('YYYY-MM-DD') : '',
            arnValidStartDate: data?.arnValidStartDate ? moment(data?.arnValidStartDate).format('YYYY-MM-DD') : '',
            nismValidEndDate: data?.nismValidEndDate ? moment(data?.nismValidEndDate).format('YYYY-MM-DD') : '',
            nismValidStartDate: data?.nismValidStartDate ? moment(data?.nismValidStartDate).format('YYYY-MM-DD') : '',
        }
        const dataJson = getFormDataFromJson(arnData);
        fetchPost(resolveURLParams(ENDPOINTS.GET_AGENT_CERTIFICATES, null, { agentCode: getAgentCode() }), dataJson, null, true
        ).then((response: any) => {
            if (response && response.operationMessage === "success") {
                Mixpanel.track(getEventName('AgentRegistration', 'completed', 'knowMore'));
            } else {
                flash.error("Something went wrong. Please try again later")
            }
            setShowSuccessPopup({ show: true, resp: response?.operationMessage, data: data });

        }).catch((error: any) => {
            flash.error("Something went wrong. Please try again later")
        })
    }

    const onClosePopup = () => {
        setShowSuccessPopup({ show: false });
        onClose();
    }

    const nonVerifiedDP = () => (agentCertificates?.isNISMCertified ? !agentCertificates?.isARNHolder : agentCertificates?.isARNHolder);

    return (
        <div>
            <LargePopup title={(showSuccessPopup.show && !isMobile) ? '' : 'Register'} closable={isMobile || !showSuccessPopup.show ? true : false} modalWidth={showSuccessPopup.show ? '420px' : '840px'} onClose={onClosePopup} style={{maxHeight: '100vh'}}>
                <KnowMoreContainer isMobile={isMobile}>
                    {!showSuccessPopup.show ? <div className={isMobile ? 'p16 bg-transparent' : 'p24'} id="KnowMoreRegisterPopup">
                        <p>You have logged in with following credentials. Turtlemint Money expert will call you shortly to explain everything you need to know to start your mutual funds career. For instant guidance call our Investment Expert on <a href='tel:18002666468' id='anchorTag'>18002666468</a> between 9am to 9pm.</p>

                        <form key={1} className={isMobile ? "mint-box p16" : ""} onSubmit={handleSubmit(onSubmitDPdetails)} >
                            <div className={`register-details ${isMobile ? '' : 'pAbsolute'}`}>
                                <p><span>Agent name </span><b>: {agentCertificates?.name}</b></p>
                                <p><span>Mobile number </span><b>: {agentCertificates?.primaryMobile}</b></p>
                                <p><span>Email ID </span><b>: {agentCertificates?.primaryEmail}</b></p>
                            </div>
                            <Row>
                                <Col xs={24} md={12} className={isMobile ? '' : 'pr16'}>
                                    <div>
                                        <p>Do you have NISM certification </p>
                                        <div className="flex-row">
                                            <CustomRadio
                                                disabled={nonVerifiedDP()}
                                                name='isNISMCertified'
                                                label="No"
                                                value="false"
                                                defaultChecked={!agentCertificates?.isNISMCertified}
                                                radiobuttonRef={register({
                                                    required: "Please enter if you are NISM holder",
                                                })}
                                            />
                                            <CustomRadio
                                                disabled={nonVerifiedDP()}
                                                name='isNISMCertified'
                                                label="Yes"
                                                value="true"
                                                radiobuttonRef={register({
                                                    required: "Please enter if you are NISM holder",
                                                })}
                                                defaultChecked={agentCertificates?.isNISMCertified}
                                            />
                                        </div>
                                    </div>

                                    {/* if no nism cert present */}
                                    {knowMoreWatch?.isNISMCertified === 'false' && <div className='ft16'>
                                        <p>We can assist you with free NISM training and certification and ARN Application.
                                            For availing this offer, please fill in your details in the form below.</p><br />
                                        <SuccessBtnWhiteGreenBorder isMobile={isMobile} onClick={nismRegisterOpenChrome} style={{ width: isMobile ? '100%' : 'auto' }}>Register now</SuccessBtnWhiteGreenBorder>
                                    </div>}


                                    {knowMoreWatch?.isNISMCertified === 'true' &&
                                        <>
                                            <InputMintDiv className='mt16'>
                                                <label htmlFor="nismCode"><b>NISM certification no.</b></label>
                                                <br />
                                                <input
                                                    disabled={nonVerifiedDP()}
                                                    className='nism-input'
                                                    name='nismCode'
                                                    type="text"
                                                    style={{ marginTop: "10px" }}
                                                    ref={register({
                                                        required: "Please enter NISM certification number",
                                                        pattern: {
                                                            value: /^[0-9]*$/,
                                                            message: "Enter only integers"
                                                        },
                                                        minLength: {
                                                            value: 10,
                                                            message: "Please enter valid NISM number"
                                                        },
                                                        maxLength: {
                                                            value: 12,
                                                            message: "Please enter valid NISM number"
                                                        }
                                                    })}
                                                />
                                                <span className="nism-txt">NISM-</span>

                                                {(errors.nismCode) ? <FormErrorMessageSpan>{errors.nismCode.message}</FormErrorMessageSpan> : null}
                                            </InputMintDiv>
                                            {knowMoreWatch?.nismCode?.length >= 10 &&
                                                <>
                                                    <Row gutter={24} className='mt16'>
                                                        <Col xs={12} md={12}>
                                                            <label htmlFor="nismValidStartDate">Test Date</label>
                                                            <br />
                                                            <Controller
                                                                control={control}
                                                                name='nismValidStartDate'
                                                                rules={{
                                                                    required: "Please select test date.",
                                                                    validate: {
                                                                        maxDate: value => {
                                                                            if (knowMoreWatch?.nismValidEndDate && value > new Date(getValues('nismValidEndDate')) || value > new Date()) return 'Please select valid date';
                                                                            return true;
                                                                        }
                                                                    }
                                                                }}
                                                                render={({ onChange, value }) => (
                                                                    <DatePicker
                                                                        disabled={nonVerifiedDP()}
                                                                        allowClear={false}
                                                                        value={value ? moment(value) : undefined}
                                                                        placeholder='dd/mm/yyyy'
                                                                        format={'DD/MM/YYYY'}
                                                                        onChange={(e) => onChange(e)}
                                                                        style={{ height: "41px", marginTop: "4px", width: "100%" }}
                                                                    />
                                                                )}
                                                            />
                                                            {(errors.nismValidStartDate) ? <FormErrorMessageSpan>{errors.nismValidStartDate.message}</FormErrorMessageSpan> : null}

                                                        </Col>
                                                        <Col xs={12} md={12}>
                                                            <label htmlFor="nismValidEndDate">Valid Till</label>
                                                            <br />
                                                            <Controller
                                                                control={control}
                                                                name='nismValidEndDate'
                                                                rules={{
                                                                    required: "Please select valid till date."

                                                                }}
                                                                render={({ onChange, value }) => (
                                                                    <DatePicker
                                                                        disabled={nonVerifiedDP()}
                                                                        allowClear={false}
                                                                        value={value ? moment(value) : undefined}
                                                                        format={'DD/MM/YYYY'}
                                                                        onChange={(e) => onChange(e)}
                                                                        placeholder='dd/mm/yyyy'
                                                                        disabledDate={date => date.isBefore(knowMoreWatch?.nismValidStartDate)}
                                                                        style={{ height: "41px", marginTop: "4px", width: "100%" }}
                                                                    />
                                                                )}
                                                            />
                                                            {(errors.nismValidEndDate) ? <FormErrorMessageSpan>{errors.nismValidEndDate.message}</FormErrorMessageSpan> : null}

                                                        </Col>
                                                    </Row>
                                                    <ArnNismImageSlab showImageSlabFor='NISM' onUploadCallBack={successCallback} onCancelClick={onCancelPreviewBtn} disabled={nonVerifiedDP()} />
                                                </>}
                                        </>
                                    }
                                </Col>
                                {knowMoreWatch?.isNISMCertified === 'true' && <Col xs={24} md={12} className={isMobile ? '' : 'bordeL pl16'}>
                                    <div>
                                        <p>Are you an ARN holder </p>
                                        <div className="flex-row mb16">
                                            <CustomRadio
                                                disabled={nonVerifiedDP()}
                                                name='isARNHolder'
                                                label="No"
                                                value="false"
                                                defaultChecked={true}
                                                radiobuttonRef={register({
                                                    required: "Please enter if you are ARN holder.",
                                                })}

                                            />
                                            <CustomRadio
                                                disabled={nonVerifiedDP()}
                                                name='isARNHolder'
                                                label="Yes"
                                                value="true"
                                                radiobuttonRef={register({
                                                    required: "Please enter if you are ARN holder.",
                                                })}
                                            />
                                        </div>
                                    </div>
                                    {knowMoreWatch?.isARNHolder === 'true' && <Row gutter={24} className='mt16'>
                                        <Col xs={12} md={12}>
                                            <InputMintDiv>
                                                <label><b>ARN no.</b></label>
                                                <br />
                                                <input
                                                    disabled={nonVerifiedDP()}
                                                    name='arnCode'
                                                    type="text"
                                                    className='arn-input'
                                                    style={{ marginTop: "10px" }}
                                                    ref={register({
                                                        required: "Please enter ARN certification number",
                                                        pattern: {
                                                            value: /^[0-9]*$/,
                                                            message: "Enter only integers"
                                                        },
                                                    })}
                                                />
                                                <span className="arn-txt">ARN-</span>

                                                {(errors.arnCode) ? <FormErrorMessageSpan>{errors.arnCode.message}</FormErrorMessageSpan> : null}
                                            </InputMintDiv>
                                        </Col>
                                        <Col xs={12} md={12}>
                                            <InputMintDiv>
                                                <label><b>EUIN no.</b></label>
                                                <br />
                                                <input
                                                    disabled={nonVerifiedDP()}
                                                    name='euin'
                                                    type="text"
                                                    className='euin-input'
                                                    style={{ marginTop: "10px" }}
                                                    ref={register({
                                                        required: "Please enter EUIN number",
                                                        pattern: {
                                                            value: /^[0-9]*$/,
                                                            message: "Enter only integers"
                                                        },
                                                        minLength: {
                                                            value: 6,
                                                            message: "Please enter 6 digits EUIN"
                                                        },
                                                        maxLength: {
                                                            value: 6,
                                                            message: "Please enter 6 digits EUIN"
                                                        }
                                                    })}
                                                />
                                                <span className="arn-txt">E</span>

                                                {(errors.euin) ? <FormErrorMessageSpan>{errors.euin.message}</FormErrorMessageSpan> : null}
                                            </InputMintDiv>
                                        </Col>
                                    </Row>}
                                    {knowMoreWatch?.arnCode &&
                                        <> <Row gutter={24} className='mt16'>
                                            <Col xs={12}>
                                                <label>Valid from</label>
                                                <br />
                                                <Controller
                                                    control={control}
                                                    name='arnValidStartDate'
                                                    rules={{
                                                        required: "Please select valid from date.",
                                                        validate: {
                                                            maxDate: value => {
                                                                if (knowMoreWatch?.arnValidEndDate && value > new Date(knowMoreWatch?.arnValidEndDate) || value > new Date()) return 'Please select valid date';
                                                                return true;
                                                            }
                                                        }
                                                    }}
                                                    render={({ onChange, value }) => (
                                                        <DatePicker
                                                            disabled={nonVerifiedDP()}
                                                            allowClear={false}
                                                            value={value ? moment(value) : undefined}
                                                            format={'DD/MM/YYYY'}
                                                            onChange={(e) => onChange(e)}
                                                            placeholder='dd/mm/yyyy'
                                                            style={{ height: "41px", marginTop: "4px", width: "100%" }}
                                                        />
                                                    )}
                                                />
                                                {(errors.arnValidStartDate) ? <FormErrorMessageSpan>{errors.arnValidStartDate.message}</FormErrorMessageSpan> : null}

                                            </Col>
                                            <Col xs={12}>
                                                <label>Valid To</label>
                                                <br />
                                                <Controller
                                                    control={control}
                                                    name='arnValidEndDate'
                                                    rules={{ required: "Please select valid to date." }}
                                                    render={({ onChange, value }) => (
                                                        <DatePicker
                                                            disabled={nonVerifiedDP()}
                                                            allowClear={false}
                                                            value={value ? moment(value) : undefined}
                                                            disabledDate={date => date.isBefore(knowMoreWatch?.arnValidStartDate)}
                                                            format={'DD/MM/YYYY'}
                                                            onChange={(e) => onChange(e)}
                                                            placeholder='dd/mm/yyyy'
                                                            style={{ height: "41px", marginTop: "4px", width: "100%" }}
                                                        />
                                                    )}
                                                />
                                                {(errors.arnValidEndDate) ? <FormErrorMessageSpan>{errors.arnValidEndDate.message}</FormErrorMessageSpan> : null}

                                            </Col>
                                        </Row>
                                            <ArnNismImageSlab showImageSlabFor='ARN' onUploadCallBack={successCallback} arnCode={knowMoreWatch?.arnCode} arnImageUploadFailure={() => setARNDuplicate(true)} onCancelClick={onCancelPreviewBtn} disabled={nonVerifiedDP()} />
                                        </>}
                                </Col>}
                            </Row>
                            <br />
                            <label>
                                <Checkbox
                                    label={<span style={{ color: COLOR.GREY }} >By submitting I agree to <ClickableSpan className="greenTxt text-underline f14" onClick={openPdfFile}>Terms and Conditons.</ClickableSpan> </span>}
                                    checked={checkedTerms}
                                    onChange={(e: any) => {
                                        setCheckedTerms(e.target.checked)
                                    }}
                                    checkboxRef={register}
                                />
                            </label>
                            <br />
                            {ARNDuplicate ? <div className='mt16 text-center'> <FormErrorMessageSpan>Agent Certificate Registration Failed. ARN Code is already mapped to other agent</FormErrorMessageSpan></div>
                                : <>{formState.isValid ? <div className={`${isMobile ? "footer" : "submitBtn"}`}>
                                    <SuccessButton type='submit' disabled={!formState.isValid || !checkedTerms || (knowMoreWatch?.nismCode && !NISMStatus) || (knowMoreWatch?.arnCode && !ARNStatus) || nonVerifiedDP()}>Submit</SuccessButton>
                                </div> : null}</>}
                        </form>
                        {isMobile && <div className='mb80'><TalkToExpert
                            title='Learn more from our Investment Expert'
                            buttonDiv={<p>
                                <img src={callBtn} alt="call expert" />
                                <b>Call Expert</b>
                            </p>} /></div>}
                    </div> :
                        <>
                            {showSuccessPopup?.operationMessage !== 'success' ? <div className='success-container text-center'>
                                <div className="success-icon">
                                    <img src={congratsTick} alt="success-icon" />
                                </div>
                                <p className="ft16"><b>Congratulations {agentCertificates?.name}</b></p>
                                <>
                                    {knowMoreWatch?.arnCode ? <p>You are now Turtlemint Money empanelled
                                        mutual funds sub-broker. All mutual fund investments through your mintpro account will be
                                        linked to sub broker code ARN - {showSuccessPopup?.data?.arnCode}.
                                        Our investment expert will shortly call you to welcome you to the Turtlemint Money family.</p>
                                        :
                                        <p>Thank you for showing interest in mutual funds business.
                                            Our investment expert will shortly contact you and explain everyting about the business.</p>

                                    }
                                </>
                            </div> :
                                <div className='success-container'>
                                    <p><b>Agent Certificate Registration Failed.</b> ARN Code is already mapped to other agent. Cannot use this ARN Number</p>
                                    <p>Please refresh the page and try again with other ARN Number</p>
                                </div>}
                            <div className={`${isMobile ? "footer" : "submitBtn pb24"}`}>
                                <SuccessButton onClick={() => { onClosePopup(); redirectToHome() }}>Explore Mutual Funds</SuccessButton>
                            </div>
                        </>
                    }
                </KnowMoreContainer>
            </LargePopup>
        </div >
    )
}

export default KnowMorePopup